export default __webpack_public_path__ + "7ca604ab6dd332308345d24cc0d135bb.svg";